import React from 'react';
import '../../../../styles/components/privacy-policy.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import i18n from '../../../../i18n';

/*
 * i18n.t(key, 'Default text') — the English default shows until you add the key
 * to your translation files, so the page works immediately.
 */
class DisclaimerPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="privacy-page">
        <HeaderBanner
          title={i18n.t('disclaimer', 'Disclaimer')}
          subtitle={i18n.t(
            'disclaimer_subtitle',
            'Important information about fees and the limits of our responsibility.'
          )}
        />

        {/* Single column — no sidebar */}
        <div
          className="privacy-container"
          style={{ gridTemplateColumns: '1fr', maxWidth: '1200px' }}
        >
          <main className="privacy-content">
            <div className="update-date">{i18n.t('last_updated')}: 27 September 2026</div>

            <div className="intro-text">
              {i18n.t(
                'dc_intro',
                'Please read this disclaimer carefully. It applies to all payments, content, listings and services available on the Mzadcom platform.'
              )}
            </div>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s1_title', '1. Administration Fee')}</h2>
              <p>
                <span className="highlight">
                  {i18n.t(
                    'dc_s1_highlight',
                    'A non-refundable administration fee of OMR 10 will be charged for each online payment transaction.'
                  )}
                </span>
              </p>
              <p>
                {i18n.t(
                  'dc_s1_p1',
                  'This fee is non-refundable in all cases, including payment cancellation, refund, or transaction reversal.'
                )}
              </p>
              <p>
                {i18n.t(
                  'dc_s1_p2',
                  'By completing an online payment on Mzadcom, you acknowledge and accept this administration fee.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s2_title', '2. General Information')}</h2>
              <p>
                {i18n.t(
                  'dc_s2_p1',
                  'The information on this platform is provided in good faith for general information purposes. While we aim to keep it accurate and up to date, we make no warranties of any kind about its completeness, accuracy or reliability.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s3_title', '3. Items Sold "As Is"')}</h2>
              <p>
                {i18n.t(
                  'dc_s3_p1',
                  'Lot descriptions, photographs and valuations are provided by sellers or based on their information. Colours in photographs may differ due to lighting and screen settings, and descriptions do not constitute a guarantee of condition.'
                )}
              </p>
              <p>
                {i18n.t(
                  'dc_s3_p2',
                  'We strongly recommend inspecting items during the viewing period before placing a bid.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s4_title', '4. Third-party Sellers')}</h2>
              <p>
                {i18n.t(
                  'dc_s4_p1',
                  'Many items on Mzadcom are offered by third-party sellers, including government entities, companies and individuals. Mzadcom acts as the auction platform operator and is not the owner of these items unless explicitly stated.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s5_title', '5. External Links')}</h2>
              <p>
                {i18n.t(
                  'dc_s5_p1',
                  'The platform may contain links to external websites that are not controlled by us. We are not responsible for the content, availability or privacy practices of those websites.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s6_title', '6. No Professional Advice')}</h2>
              <p>
                {i18n.t(
                  'dc_s6_p1',
                  'Nothing on this platform constitutes legal, financial, investment or technical advice. You should seek independent professional advice before making any significant purchasing decision.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s7_title', '7. Limitation of Liability')}</h2>
              <p>
                {i18n.t(
                  'dc_s7_p1',
                  'To the extent permitted by the laws of the Sultanate of Oman, Mzadcom shall not be liable for any loss or damage arising from reliance on information on this platform or from the temporary unavailability of the service.'
                )}
              </p>
            </section>

            <section className="privacy-section">
              <h2>{i18n.t('dc_s8_title', '8. Contact Us')}</h2>
              <p>
                {i18n.t(
                  'dc_s8_p1',
                  'If you have any questions about this disclaimer or the administration fee, please contact us:'
                )}
              </p>
              <div className="contact-box">
                <p>
                  <strong>{i18n.t('group_auction')}</strong>
                </p>
                <p>{i18n.t('office_address_info')}</p>
                <p>
                  Email: <a href="mailto:info@mzadcom.om">info@mzadcom.om</a>
                </p>
              </div>
            </section>
          </main>
        </div>
      </div>
    );
  }
}

export default DisclaimerPage;
